// Libs
import { createSlice } from '@reduxjs/toolkit';
// Others
import {
  changeStatusInvoice,
  createInvoice,
  deleteInvoice,
  getDetailInvoice,
  getListInvoice,
  sendMailInvoice,
  updateInvoice,
} from './invoiceThunk';

export interface IInvoiceState {
  isRefreshInvoiceList: boolean;
}

export const initialState: IInvoiceState = {
  isRefreshInvoiceList: false,
};

const invoiceSlice = createSlice({
  name: 'invoice',
  initialState,
  reducers: {
    setRefreshInvoiceList(state, action) {
      state.isRefreshInvoiceList = action.payload;
    },
  },
  extraReducers(builder) {
    // GET: Get list invoice
    builder
      .addCase(getListInvoice.pending, (_state) => {})
      .addCase(getListInvoice.fulfilled, (state) => {
        state.isRefreshInvoiceList = false;
      })
      .addCase(getListInvoice.rejected, (_state) => {});

    // GET: Get detail invoice
    builder
      .addCase(getDetailInvoice.pending, (_state) => {})
      .addCase(getDetailInvoice.fulfilled, (_state) => {})
      .addCase(getDetailInvoice.rejected, (_state) => {});

    // POST: Create invoice
    builder
      .addCase(createInvoice.pending, (_state) => {})
      .addCase(createInvoice.fulfilled, (state) => {
        state.isRefreshInvoiceList = true;
      })
      .addCase(createInvoice.rejected, (_state) => {});

    // PUT: Update  invoice
    builder
      .addCase(updateInvoice.pending, (_state) => {})
      .addCase(updateInvoice.fulfilled, (state) => {
        state.isRefreshInvoiceList = true;
      })
      .addCase(updateInvoice.rejected, (_state) => {});

    // DELETE: Delete invoice
    builder
      .addCase(deleteInvoice.pending, (_state) => {})
      .addCase(deleteInvoice.fulfilled, (state) => {
        state.isRefreshInvoiceList = true;
      })
      .addCase(deleteInvoice.rejected, (_state) => {});

    // PUT: Send mail invoice
    builder
      .addCase(sendMailInvoice.pending, () => {})
      .addCase(sendMailInvoice.fulfilled, (state) => {
        state.isRefreshInvoiceList = true;
      })
      .addCase(sendMailInvoice.rejected, () => {});

    // PUT: Change Status Invoice
    builder
      .addCase(changeStatusInvoice.pending, () => {})
      .addCase(changeStatusInvoice.fulfilled, (state) => {
        state.isRefreshInvoiceList = true;
      })
      .addCase(changeStatusInvoice.rejected, () => {});
  },
});

// Action
export const invoiceActions = invoiceSlice.actions;

// Selectors
// Reducer
const invoiceReducer = invoiceSlice.reducer;
export default invoiceReducer;
